import React, { SyntheticEvent } from 'react'
import { IIntegration } from '@api/integration/types'
import { Flex, List, Item } from '@ui'
import { H4 } from '@blueprintjs/core'
import css from './integrations.module.scss'

export default function ActiveSection({
  active,
  activeSection,
  setActiveIntegration,
}: {
  active: IIntegration[]
  activeSection: string
  setActiveIntegration: (integration: IIntegration | null) => void
}) {
  const items = active.filter(({ category }) =>
    activeSection === 'All' ? true : category === activeSection
  )

  if (!items.length) {
    return null
  }

  return (
    <div style={{ marginBottom: 40 }}>
      <div style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 25 }}>Active</div>
      <List>
        {items.map((integration) => (
          <Item key={integration.id}>
            <ActiveCard
              integration={integration}
              onClick={() => setActiveIntegration(integration)}
            />
          </Item>
        ))}
      </List>
    </div>
  )
}

const ActiveCard = ({
  integration,
  onClick,
}: {
  integration: IIntegration
  onClick: (e: SyntheticEvent<HTMLDivElement>) => void
}) => (
  <div className={css.card_wrapper}>
    <Flex align="flex-start" onClick={onClick}>
      <img
        width="50"
        height="auto"
        alt="integration"
        src={integration.image}
        style={{ marginRight: 20 }}
      />
      <Flex direction="column" align="flex-start">
        <H4>{integration.name}</H4>
        <div style={{ color: 'var(--grey1)', fontSize: 14 }}>{integration.description}</div>
      </Flex>
    </Flex>
  </div>
)
